import * as T from '@/core/configs/types'
// export const Number = 'number'
// export const String = 'string'

// export const Tag = 'tag'
// export const Text = 'text'
// export const TextInput = 'textInput'
// export const TextArea = 'textArea'
// export const TimeSelect = 'timeSelect'
// export const TimeRange = 'timeRange'
// export const TimeTargetSelect = 'timeTargetSelect'
// export const NumberInput = 'numberInput'
// export const Select = 'select'
// export const RemoteSelect = 'remoteSelect'
// export const EditFormItemTypes = [
//   TextInput,
//   TextArea,
//   TimeSelect,
//   TimeRange,
//   Select,
//   RemoteSelect,
//   TimeTargetSelect,
//   NumberInput
// ]

export const FormModes = {
  COMPACT: {
    cols: 6
  },
  DENSE: {
    cols: 5
  },
  NORMAL: {
    cols: 4
  },
  SPARSE: {
    cols: 3
  },
  LOOSE: {
    cols: 2
  }
}

export const FormTypeMixin = {
  data: function () {
    return {
      Text,
      // TextInput,
      // TextArea,
      // RemoteSelect,
      // Tag,
      // Select,
      // TimeSelect,
      // TimeRange,
      // NumberInput,
      // EditFormItemTypes,
      FormModes
    }
  },
  methods: {
    isEditType(type) {
      return this.EditFormItemTypes.includes(type)
    }
  }
}

export const LabelInfoDict = {
  sku: {
    label: 'SKU',
    key: 'sku',
    span: 1,
    type: T.TextInput,
    value: 'CD123456789',
    validators: [T.RequiredValidator]
  },
  boxes: {
    label: 'Boxes',
    key: 'boxes',
    span: 1,
    type: T.NumberInput,
    value: 12,
    validators: [T.PositiveValidator]
  },
  pallet_id: {
    label: 'Pallet ID',
    key: 'pallet_id',
    span: 1,
    type: T.TextInput,
    value: 'TPR0418',
    validators: [T.RequiredValidator]
  },
  pallet_count: {
    label: 'Pallet Count',
    key: 'pallet_count',
    span: 1,
    type: T.NumberInput,
    value: 1,
    validators: [T.PositiveValidator]
  },
  order_no: {
    label: '理货单号',
    key: 'order_no',
    span: 2,
    type: T.TextInput,
    default: 'DLT20220303000130BS',
    validators: [T.RequiredValidator]
  }
}
